import dayjs from "dayjs";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { getThousandComma } from "../../../Api/ApiCommon";
import { GetSubscriptionSetData } from "../../../Api/ServiceDatas";
import LineBtn from "../../../components/Button/LineBtn";
import DotStatus from "../../../components/DefaultStyles/DotStatus";
import LineBox from "../../../components/DefaultStyles/LineBox";
import Loader from "../../../components/DefaultStyles/Loader";
import PageTitle from "../../../components/DefaultStyles/PageTitle";
import SpaceBetween from "../../../components/DefaultStyles/SpaceBetween";
import { sunsetDetailButtonType } from "../../../components/pages/Manage/Sunset/SunsetDetailButtons";
import SunsetFilter from "../../../components/pages/Manage/Sunset/SunsetFilter";
import { PartyInfoFilterContainer } from "../../../components/pages/Party/PartyInfo/PartyInfoFilter";
import Pagination from "../../../components/Table/Pagination";
import Table, {
  TableBody,
  TableBodyItem,
} from "../../../components/Table/Table";
import { useApi } from "../../../hooks/useApi";
import { TotalCount } from "../../Users/UserInfo";
import { getSubsNameBySubsId3 } from "../../../AdminApi/3.0_utils";

export interface ISunset {
  altemp: number;
  customvar?: {
    alertcat: string;
  };
  id: number;
  indate: string;
  isexec: number;
  notifyDate: string;
  notifyType: number;
  srisSubs: number;
  ssetDate: string;
  sriseDate: string;
  ssetParty: [];
  ssetSubs: number;
  ssetType: number;
  writer: string;
}

export interface ISunsetFilter {
  type: string;
  value: string;
}

export default function Sunset() {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const setButtonType = useSetRecoilState(sunsetDetailButtonType);
  const [sunsetFilter, setSunsetFilter] = useState<ISunsetFilter>({
    type: "",
    value: "",
  });

  const { response, loading } = useApi({
    method: "get",
    url:
      `sunset?page=${page}&size=10` +
      (sunsetFilter?.type !== "" && sunsetFilter?.value !== ""
        ? `&${sunsetFilter?.type}=${sunsetFilter?.value}`
        : ``),
  });

  const sunsetTableHeader = [
    "NO",
    "통지 상태",
    "일몰 대상 서비스",
    "신규 전환 서비스",
    "적용 대상 파티",
    "일몰 통지일",
    "통지 방식",
    "정책 변경일",
    "일몰 실행일",
    "일몰 타입",
    "일몰 템플릿",
    "작성자",
    "작성 일시",
    "상세",
  ];

  return (
    <>
      <PageTitle title="일몰 관리" />

      <PartyInfoFilterContainer>
        <LineBtn
          btnText="일몰 설정하기"
          icon="nights_stay"
          btnHeight={38}
          btnColor="red"
          btnClickEvent={() => {
            setButtonType("input");
            navigate(`/linkid-manage/sunset/setting`);
          }}
        />

        <SunsetFilter
          sunsetFilter={sunsetFilter}
          setSunsetFilter={setSunsetFilter}
        />
      </PartyInfoFilterContainer>

      <LineBox>
        <Table tableHeadData={sunsetTableHeader} tableMinWidth={700}>
          <>
            {response?.data?.items?.map((d: ISunset, index: number) => {
              return (
                <TableBody key={index}>
                  <TableBodyItem isNeedLineThrough={d?.isexec === 2}>
                    {d?.id}
                  </TableBodyItem>
                  <TableBodyItem>
                    <DotStatus
                      text={
                        d?.isexec === 0
                          ? "예정"
                          : d?.isexec === 1
                          ? "완료"
                          : "취소"
                      }
                      color={
                        d?.isexec === 0
                          ? "#ffb128"
                          : d?.isexec === 1
                          ? "#00c7c7"
                          : "#aaaaaa"
                      }
                      size="sm"
                    />
                  </TableBodyItem>
                  <TableBodyItem
                    isNeedLineThrough={d?.isexec === 2}
                    isKeepAll={true}
                  >
                    {d?.ssetSubs}_{getSubsNameBySubsId3(d?.ssetSubs)}
                  </TableBodyItem>
                  <TableBodyItem
                    isNeedLineThrough={d?.isexec === 2}
                    isKeepAll={true}
                  >
                    {d?.srisSubs}_{getSubsNameBySubsId3(d?.srisSubs)}
                  </TableBodyItem>
                  <TableBodyItem isNeedLineThrough={d?.isexec === 2}>
                    {d?.ssetParty?.length > 0
                      ? d?.ssetParty.toString()
                      : d?.ssetParty?.length === 0
                      ? "전체"
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem
                    isNeedLineThrough={d?.isexec === 2}
                    isKeepAll={true}
                  >
                    {dayjs(d?.notifyDate).format("YYYY-MM-DD")}
                  </TableBodyItem>
                  <TableBodyItem isNeedLineThrough={d?.isexec === 2}>
                    {d?.notifyType === 1
                      ? "2회"
                      : d?.notifyType === 2
                      ? "매일"
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem
                    isNeedLineThrough={d?.isexec === 2}
                    isKeepAll={true}
                  >
                    {dayjs(
                      d?.sriseDate ?? dayjs(d?.ssetDate).add(1, "d")
                    ).format("YYYY-MM-DD")}
                  </TableBodyItem>
                  <TableBodyItem
                    isNeedLineThrough={d?.isexec === 2}
                    isKeepAll={true}
                  >
                    {dayjs(d?.ssetDate).format("YYYY-MM-DD")}
                  </TableBodyItem>
                  <TableBodyItem
                    isNeedLineThrough={d?.isexec === 2}
                    isKeepAll={true}
                  >
                    {d?.ssetType === 1
                      ? "OPT-IN"
                      : d?.ssetType === 2
                      ? "OPT-OUT"
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem
                    isNeedLineThrough={d?.isexec === 2}
                    isKeepAll={true}
                  >
                    {d?.customvar?.alertcat ?? "-"}
                  </TableBodyItem>
                  <TableBodyItem isNeedLineThrough={d?.isexec === 2}>
                    {d?.writer !== "" ? d?.writer ?? "-" : "-"}
                  </TableBodyItem>
                  <TableBodyItem isNeedLineThrough={d?.isexec === 2}>
                    {d?.indate
                      ? dayjs(d?.indate).format("YYYY-MM-DD HH:mm:ss")
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem>
                    <LineBtn
                      btnText="상세"
                      btnClickEvent={() => {
                        setButtonType("view");
                        navigate(`/linkid-manage/sunset/${d?.id}`, {
                          state: {
                            sunsetData: d,
                          },
                        });
                      }}
                    />
                  </TableBodyItem>
                </TableBody>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +(response?.data?.totalCount ?? 0) : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      {loading && <Loader />}
    </>
  );
}
